import { render, staticRenderFns } from "./WebsiteDetailScreen.vue?vue&type=template&id=6f807985&scoped=true&lang=pug"
import script from "./WebsiteDetailScreen.vue?vue&type=script&lang=ts"
export * from "./WebsiteDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./WebsiteDetailScreen.vue?vue&type=style&index=0&id=6f807985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f807985",
  null
  
)

export default component.exports